'use strict';

import angular from 'angular';
import grid from 'angular-ui-grid';

export class CounterComponent {

  closeWindow: Function;

  data;
  counter;
  modules;
  module;

  /*@ngInject*/
  constructor($scope, Storage, WindowService, $q) {
    this.Storage = Storage;
    this.scope   = $scope;
    this.Promise = $q.defer;

    this.closeWindow = WindowService.delItem;
  }

  $onInit() {
    this.module  = this.data.module;
    this.counter = this.data.counter || {
      categoryId: this.data.category._id
    };
  }

  save() {
    return this.Storage.saveCounter(this.counter)
      .then(() => this.close())
      .catch(err => console.error(err));
  }

  close() {
    this.closeWindow(this.data.id);
  }
}

export default angular.module('storageApp.counter', [])
  .component('counter', {
    bindings: {data: '='},
    transclude: true,
    template: require('./counter.html'),
    controller: CounterComponent,
    controllerAs: 'counterCtrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/counter/counter.component.js